import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PDF from "./PDF";
import { Document, Page, pdfjs } from "react-pdf";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { connect } from "react-redux";
import withSizes from "react-sizes";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import ChatbotReEnterData from "./ChatbotReEnterData";
import * as actions from "../../store/actions/index";
import UploadDocsSingleFile from "../../containers/Onboarding/UploadDocsSingleFile";
import CircularProgress from '@material-ui/core/CircularProgress';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = (theme) => ({
  body: {
    backgroundColor: "grey",
  },
  sigPad: {
    backgroundColor: "white",
    width: "100%",
    height: "100%",
  },
  container: {
    // margin: theme.spacing.unit * 5,
    //width: '50%',
    //minwidth: '30%',
    width: 400,
    height: 250,
    maxHeight: 300,
    minHeight: 200,
    //top: '10%',
    // left: '10%',
  },
  sigContainer: {
    maxWidth: "100%",
    minwidth: "30%",
    height: "80%",
    alignItems: "left",
    backgroundColor: "#fff",
  },
  button: {
    //width: '100%',
  },
  sigImage: {
    backgroundSize: "200px 50px",
    width: "200px",
    height: "200px",
    backgroundColor: "white",
  },
  pdfMargin: {
    // paddingRight: 10
  },
  bInput: {
    background: "rgba(255, 255, 255, 0.5)",
    outline: "0",
    color: "#99192D",
    wordWrap: "break-word",
    wordBreak: "break-word",
    border: "2px solid #99192D",
    paddingTop: "15px",
    paddingBottom: "15px",
    borderRadius: "25px",
    textTransform: "none",
    //   height: "30px",
    marginLeft: "3px",
    marginRight: "3px",
    boxSizing: "border-box",
    fontSize: "16px",
    "&:hover": {
      color: "white",
    },
  },
});

class ReadPDF extends Component {
  state = {
    trimmedDataURL: null,
    userType: "",
    reEnterData: false,
    uniqueId: localStorage.getItem("token"),
    lang: localStorage.getItem("language"),
    typeOfAccount: localStorage.getItem("typeOfAccount"),
    waitingForAdobeToFinish: true
  };

  switchReEnterData = () => {
    if (this.props.claimantUniqueId == this.state.uniqueId) {
      this.setState({
        userType: "claimant",
      });
    } else if (this.props.respondentUniqueId == this.state.uniqueId) {
      this.setState({
        userType: "respondent",
      });
    }

    if (this.state.userType == "claimant") {
      this.setState({
        reEnterData: !this.state.reEnterData,
      });
      // this.props.removeConfirmButton()
      // window.open('/odr/#/reenterdata/')
      // localStorage.removeItem('token');
      // localStorage.removeItem('tokenExpirationDate');
      // localStorage.removeItem('caseId');
      // window.open('https://www.hkarbsoc.org.hk/odr','_blank');
    } else if (this.state.userType == "respondent") {
      this.props.changeResponseToReEnter(this.props.caseId);
    }
  };

  componentDidMount() {
    if (this.props.claimantUniqueId == this.state.uniqueId) {
      this.setState({
        userType: "claimant",
      });
    } else if (this.props.respondentUniqueId == this.state.uniqueId) {
      this.setState({
        userType: "respondent",
      });
    }
    setTimeout(() => {
      this.setState({ waitingForAdobeToFinish: false });
    },10000)
  }

  render() {
    const { classes } = this.props;
    let { trimmedDataURL } = this.state;
    let fileURL = "", fileDocURL="";

    if (this.state.userType == "claimant") {
      fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}`;
      fileDocURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getDoc/?id=${this.props.conversationId}_arbitrationNotice`;
      console.log("ReadPdf: fileUrl: " + fileURL);
    } else if (this.state.userType == "respondent") {
      fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_response`;
      fileDocURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getDoc/?id=${this.props.conversationId}_response`;
      console.log("ReadPdf: fileUrl: " + fileURL);
    }

    if (this.state.waitingForAdobeToFinish) {
      return (<div style={{ marginBottom:'100px' }}><CircularProgress
        size={50}
        thickness={3}
        className={classes.progress}
    /></div>)
    }
    else{
      return (
        <Grid
          container
          spacing={12}
          alignItems="center"
          style={{ marginBottom: "80px" }}
          justify="center"
        >
          {!this.state.reEnterData && (
            <Grid item md={12} lg={12} sm={12} xs={12}>
              <PDF
                isDesktop={this.props.isMobile}
                fileURLNoName={fileURL}
                file={fileURL}
                wordFile={fileDocURL}
              />
            </Grid>
          )}
  
          {this.state.reEnterData && (
            <Grid item md={12} lg={12} sm={12} xs={12}>
              <ChatbotReEnterData caseId={this.props.caseId} />
            </Grid>
          )}
          <div>
            <div>
              <UploadDocsSingleFile doc_type={ this.state.userType == 'claimant' ? "arbitration_notice" : 'response'} />
            </div>
            <div
              style={{
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div>
                {this.props.caseData.kind_of_claim == "money_lent" &&
                  !this.state.reEnterData && (
                    <p
                      style={{
                        textAlign: "center",
                        fontWeight: "bold",
                        marginTop: "50px",
                        marginBottom: "5px",
                      }}
                    >
                      {this.context.t(
                        "Please read the contents and choose to amend or confirm them."
                      )}
                    </p>
                  )}
                <br></br>
                {!(this.props.caseData.kind_of_claim == "money_lent") && (
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    style={{
                      marginTop: "20px",
                    }}
                    className={classes.bInput}
                    onClick={this.props.handleComplete}
                  >
                    {this.context.t("Next")}
                  </Button>
                )}
                {this.props.caseData.kind_of_claim == "money_lent" && (
                  <Button
                    variant="contained"
                    type="submit"
                    color="primary"
                    style={{
                      marginTop: "20px",
                      //  marginRight:'80px',
                      marginLeft: !this.state.reEnterData
                        ? this.state.lang == "en"
                          ? "137px"
                          : "70px"
                        : "0px",
                      paddingLeft: !this.state.reEnterData
                        ? this.state.lang == "en"
                          ? "28px"
                          : "18px"
                        : "",
                      paddingRight: !this.state.reEnterData
                        ? this.state.lang == "en"
                          ? "28px"
                          : "18px"
                        : "",
                    }}
                    className={classes.bInput}
                    onClick={this.switchReEnterData}
                  >
                    {this.state.userType == "claimant"
                      ? !this.state.reEnterData && this.context.t("Amend")
                      : this.context.t("Re-enter")}
                    {this.state.reEnterData && this.context.t("Confirm")}
                  </Button>
                )}
                <br></br>
                {this.props.caseData.kind_of_claim == "money_lent" &&
                  !this.state.reEnterData && (
                    <Button
                      variant="contained"
                      type="submit"
                      color="primary"
                      style={{
                        marginTop: "20px",
                        marginLeft: this.state.lang == "en" ? "140px" : "70px",
                        paddingLeft: !this.state.reEnterData
                          ? this.state.lang == "en"
                            ? "25px"
                            : "18px"
                          : "",
                        paddingRight: !this.state.reEnterData
                          ? this.state.lang == "en"
                            ? "25px"
                            : "18px"
                          : "",
                      }}
                      className={classes.bInput}
                      onClick={this.props.handleComplete}
                    >
                      {this.context.t("Confirm")}
                    </Button>
                  )}
              </div>
            </div>
          </div>
        </Grid>
      );
    }
    
  }
}

const mapStateToProps = (state) => {
  return {
    caseId: state.caseInfo.caseId,
    claimantUniqueId: state.caseInfo.claimantUniqueId,
    caseData: state.caseInfo.caseData,
    respondentUniqueId: state.caseInfo.respondentUniqueId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: () => dispatch(actions.logout()),
    getCaseInfo: (caseId, uniqueId) =>
      dispatch(actions.getCaseInfo(caseId, uniqueId)),
    changeResponseToReEnter: (caseId) =>
      dispatch(actions.changeResponseToReEnter(caseId)),
  };
};

const mapSizesToProps = (sizes) => ({
  isMobile: withSizes.isMobile(sizes),
  isTablet: withSizes.isTablet(sizes),
  isDesktop: withSizes.isDesktop(sizes),
  isGtMobile: withSizes.isGtMobile(sizes),
  isGtTablet: withSizes.isGtTablet(sizes),
  isStTablet: withSizes.isStTablet(sizes),
  isStDesktop: withSizes.isStDesktop(sizes),
  isTabletAndGreater: withSizes.isTabletAndGreater(sizes),
  isTabletAndSmaller: withSizes.isTabletAndSmaller(sizes),
});

ReadPDF.contextTypes = {
  t: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withSizes(mapSizesToProps)(withRouter(ReadPDF))));
